module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.card) ? _c('div', {
    ref: "stacks",
    staticClass: "backdrop",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.dismissModal
    }
  }, [_c('form', {
    staticClass: "edit-card-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h3', [_vm._v("Found in " + _vm._s(_vm.card.stackCount) + " stack(s)")]), _vm._v(" "), _vm._l((_vm.stacks), function(stack) {
    return _c('div', [(_vm.user) ? _c('div', [(stack.key != _vm.card.boundStack) ? _c('div', [_c('p', [_c('a', {
      attrs: {
        "href": 'stacks/' + stack.slug
      }
    }, [_vm._v(_vm._s(stack.title))]), _vm._v(" "), (stack.cards) ? _c('span', [(stack.cards.hasOwnProperty(_vm.card.key)) ? _c('span', [_vm._v("\n                added\n                "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.removeStack(_vm.card, stack)
        }
      }
    }, [_vm._v("remove")])]) : _c('span', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.addStack(_vm.card, stack)
        }
      }
    }, [_vm._v("add")])])]) : _c('span', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.addStack(_vm.card, stack)
        }
      }
    }, [_vm._v("add")])])])]) : _vm._e()]) : _c('div', [(stack.cards.hasOwnProperty(_vm.card.key)) ? _c('span', [_c('p', [_c('a', {
      attrs: {
        "href": '/stack/' + stack.slug
      }
    }, [_vm._v(_vm._s(stack.title))])])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Done")])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a73b1ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/StackModal.vue
// module id = 203
// module chunks = 1